import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { ContactUs } from '../models/contact-us.model';
import { ContactUsService } from '../service/contact-us.service';

@Component({
    selector: 'app-modal-contact-us',
    templateUrl: './modal-contact-us.component.html',
    styleUrls: ['./modal-contact-us.component.scss'],
    standalone: false
})
export class ModalContactUsComponent implements OnInit {

  submitted = false;

  form = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    name: ['', [Validators.required, Validators.minLength(6)]],
    business: ['', [Validators.required, Validators.minLength(3)]],
    subject: ['', [Validators.required, Validators.minLength(10)]]
  });

  constructor(
    public bsModalRef: BsModalRef,
    private contactUsService: ContactUsService,
    private fb: FormBuilder
   ) { }

  ngOnInit(): void {

  }

  sendContact(): void{
    if(this.form.valid){
      this.submitted = true;
      const contact: ContactUs =  this.form.getRawValue();
      this.contactUsService.sendContactForm(contact).subscribe(
        () => {
          this.form.reset();
          this.bsModalRef.hide();
        });
    }else{
      this.submitted = false;
    }
  }

  get loginFormControls() {
    return this.form.controls;
  }

}
